<div style="display: flex; flex-direction: column; height: 100%">
    <div class="company-toolbar">
        <div class="first-row">
            <div
                style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    gap: 5px;
                    padding-top: 11px;
                "
            >
                <div
                    style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        gap: 5px;
                        justify-content: center;
                    "
                >
                    <div>
                        <app-toggle
                            [option]="settingItemNetGross.options"
                        ></app-toggle>
                    </div>
                    <div>
                        <app-toggle
                            [option]="settingItemCurrency.options"
                        ></app-toggle>
                    </div>
                </div>
                <div
                    style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    "
                >
                    <div>
                        <app-checkbox
                            [option]="settingItemShowTotalRevenue.options"
                        ></app-checkbox>
                    </div>
                    <div>
                        <app-checkbox
                            [option]="settingItemShowInappRevenue.options"
                        ></app-checkbox>
                    </div>
                    <div>
                        <app-checkbox
                            [option]="settingItemShowAdRevenue.options"
                        ></app-checkbox>
                    </div>
                </div>
            </div>
            <div
                style="
                    display: flex;
                    /* width: 100%; */
                    flex-direction: column;
                    gap: 5px;
                    flex-grow: 1;
                "
            >
                <div style="display: flex; justify-content: space-between">
                    <div
                        *ngFor="let link of values(filterDashboardItemLinks)"
                        style="flex-grow: 1"
                    >
                        <app-category-filter-dashboard-item
                            *ngIf="
                                link.dashboardItemFactory.componentClass ==
                                'CategoryFilterDashboardItem'
                            "
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        >
                        </app-category-filter-dashboard-item>
                        <app-date-picker
                            *ngIf="
                                link.dashboardItemFactory.componentClass ==
                                'DateRangeFilterDashboardItem'
                            "
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        >
                            ></app-date-picker
                        >
                        <app-segment-filter
                            *ngIf="
                                link.dashboardItemFactory.componentClass ==
                                'SegmentsFilterDashboardItem'
                            "
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-segment-filter>
                    </div>
                </div>
                <div style="display: flex; gap: 5px">
                    <button
                        nz-button
                        nzType="primary"
                        (click)="applyChangedFilters()"
                        [disabled]="isApplyButtonDisabled"
                        style="width: 100%"
                        nzSize="small"
                    >
                        Apply
                    </button>
                    <button
                        nz-button
                        color="primary"
                        (click)="standardDashboardInitialize()"
                        style="width: 100px"
                        nzSize="small"
                    >
                        Restore defaults
                    </button>
                    <button
                        nz-button
                        color="primary"
                        (click)="reloadData()"
                        style="width: 100px"
                        nzSize="small"
                    >
                        Reload data
                    </button>
                </div>
            </div>
            <div style="padding-top: 10px">
                <app-saved-dashboard-view></app-saved-dashboard-view>
            </div>
        </div>
        <div class="company-legend-container">
            <app-common-legend></app-common-legend>
        </div>
    </div>
    <div class="company-main-content">
        <div class="grid-container">
            <div nz-row [nzGutter]="5">
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [avg_user_lifetime_d7]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [avg_user_lifetime_d30]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [avg_user_lifetime_d30_monthly]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="8" *ngFor="let link of [dau]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [stickiness_dau_mau]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [new_users_daily]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="8" *ngFor="let link of [monthly_avg_dau]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [mau]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [new_users_monthly]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <!-- <mat-divider></mat-divider> -->
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="8" *ngFor="let link of [daily_income]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [daily_ads_cost]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [first_margin_daily]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="8" *ngFor="let link of [monthly_income]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [monthly_ads_cost]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [first_margin_monthly]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <!-- <mat-divider></mat-divider> -->
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="8" *ngFor="let link of [arpdau]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [running_arpu]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [conversion_rate]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <div nz-row [nzGutter]="5">
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [monthly_avg_arpdau]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [monthly_arpu_d30]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [monthly_conversion_rate]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <!-- <mat-divider></mat-divider> -->
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="8" *ngFor="let link of [daily_cpi]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [roas_d7_daily]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [roas_d30_daily]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="8" *ngFor="let link of [monthly_cpi]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [roas_d7_monthly]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [roas_d30_monthly]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <!-- <mat-divider></mat-divider> -->
            <div nz-row [nzGutter]="5">
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [ads_engagement_rate]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div nz-col nzSpan="8" *ngFor="let link of [ads_impressions]">
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [impressions_per_deu]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
            <div nz-row [nzGutter]="5">
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [monthly_engagement_rate]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [ads_impressions_monthly]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
                <div
                    nz-col
                    nzSpan="8"
                    *ngFor="let link of [impressions_per_deu_monthly]"
                >
                    <app-echarts-dashboard-item
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-echarts-dashboard-item>
                </div>
            </div>
        </div>
    </div>
</div>
